<template>
  <div class="Comics container-fluid">

      <div id="buttonsTop row" >
        <div id="first" class="col-3">
          <div :class="prevBtn" @click="firstOrLast(0)">
            <img src="@/assets/visual/gamecomic/first.png">
          </div>
        </div>
        <div id="previous" class="col-3">
          <div :class="prevBtn" @click="changeImg(-1)">
            <img src="@/assets/visual/gamecomic/previous.png">
          </div>
          </div>
        <div id="next" class="col-3">
          <div :class="nextBtn" @click="changeImg(1)">
            <img src="@/assets/visual/gamecomic/next.png">
          </div>
        </div>
        <div id="last" class="col-3">
          <div :class="nextBtn" @click="firstOrLast((comics.length - 1))">
            <img src="@/assets/visual/gamecomic/last.png">
          </div>

        </div>
       </div>
      <div class="row gameComic">
        <div class="col-12" v-show="myIndex == 0">
          <strong>Blog Comic</strong><br>Journal on the ups and downs of game creation
        </div>
      </div>
       <div class="row comicSize">
         <div class="col-12">
          <div class="row" id="numberhere">
            <div class="col-12">
              <img :src="getTitle" >
            </div>
          </div>

         <div class="row" id="comicHere">
           <div class="col-12">
             <img :src="getMainImage">
           </div>
          
        </div>
         </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'Comics',
  mounted: function(){

    // get cookie here and set the title and main image
    // set index as cookie number

    // random image for testing is 27
    this.titleImage = this.comics[this.myIndex].number
    this.mainImage = this.comics[this.myIndex].picture

  },
  methods: {
    firstOrLast: function(number){
       // set the images as first or last comic

       if(this.titleImage == this.comics[number].number){
         //set background color of btn to red
       }

      this.titleImage = this.comics[number].number
      this.mainImage = this.comics[number].picture
      this.myIndex = number
      this.isActive = false
    },
    changeImg: function(number){
      if(this.myIndex == 0 && number < 0){
        this.isActive = false
               if(this.titleImage == this.comics[number].number){
              //set background color of btn to red
              }
        return

      }else if(this.myIndex > this.comics.length -1) {
        this.myIndex = this.comics.length - 1
        this.isActive = false
      }else{
        console.log(this.myIndex)
        this.myIndex += number
        this.titleImage = this.comics[this.myIndex].number
        this.mainImage = this.comics[this.myIndex].picture
        this.isActive = true
      }
    }
  },
  computed:{
    getTitle: function(){
      return this.titleImage
    },
    getMainImage: function(){
      return this.mainImage
    },
    nextBtn: function(){
      if (this.myIndex >= this.comics.length-1){
        return {disableCtrlBtn:true}
      }else{
        return {ctrlBtn:true}
      }
    },
    prevBtn: function(){
      if (this.myIndex <= 0){
        return {disableCtrlBtn:true}
      }else{
        return {ctrlBtn:true}
      }
    }
  },
  data: ()=>({
      myIndex : 0,
      titleImage: '',
      mainImage: '',
      isActive: true,
      comics: [
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_000.png") , "title" : "Team", "number" : "" },
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_001.png") , "title" : "One" , "number" : require("@/assets/visual/gamecomic/Comic_1.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_002.png") , "title" : "Two" , "number" : require("@/assets/visual/gamecomic/Comic_2.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_003.png") , "title" : "Three (Extended)" , "number" : require("@/assets/visual/gamecomic/Comic_3.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_004.png") , "title" : "Four" , "number" : require("@/assets/visual/gamecomic/Comic_4.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_005.png") , "title" : "Five" , "number" : require("@/assets/visual/gamecomic/Comic_5.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_006.png") , "title" : "Six" , "number" : require("@/assets/visual/gamecomic/Comic_6.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_007.png") , "title" : "Seven" , "number" : require("@/assets/visual/gamecomic/Comic_7.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_008.png") , "title" : "Eight" , "number" : require("@/assets/visual/gamecomic/Comic_8.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_009.png") , "title" : "Nine" , "number" : require("@/assets/visual/gamecomic/Comic_9.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_010.png") , "title" : "Ten" , "number" : require("@/assets/visual/gamecomic/Comic_10.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_011.png") , "title" : "Eleven" , "number" : require("@/assets/visual/gamecomic/Comic_11.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_012.png") , "title" : "Twelve" , "number" : require("@/assets/visual/gamecomic/Comic_12.png")},
				{"picture" : require("@/assets/visual/gamecomic/TeamComic_013.png") , "title" : "Thirteen" , "number" : require("@/assets/visual/gamecomic/Comic_13.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_014.png") , "title" : "Fourteen" , "number" : require("@/assets/visual/gamecomic/Comic_14.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_015.png") , "title" : "Fiftenne" , "number" : require("@/assets/visual/gamecomic/Comic_15.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_016.png") , "title" : "Sixteen" , "number" : require("@/assets/visual/gamecomic/Comic_16.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_017.png") , "title" : "Seventeen" , "number" : require("@/assets/visual/gamecomic/Comic_17.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_018.png") , "title" : "Eighteen" , "number" : require("@/assets/visual/gamecomic/Comic_18.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_019.png") , "title" : "Nineteen" , "number" : require("@/assets/visual/gamecomic/Comic_19.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_020.png") , "title" : "Twenty" , "number" : require("@/assets/visual/gamecomic/Comic_20.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_021.png") , "title" : "Twenty-one" , "number" : require("@/assets/visual/gamecomic/Comic_21.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_022.png") , "title" : "Twenty-two" , "number" : require("@/assets/visual/gamecomic/Comic_22.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_023.png") , "title" : "Twenty-three" , "number" : require("@/assets/visual/gamecomic/Comic_23.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_024.png") , "title" : "Twenty-four" , "number" : require("@/assets/visual/gamecomic/Comic_24.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_025.png") , "title" : "Twenty-five" , "number" : require("@/assets/visual/gamecomic/Comic_25.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_026.png") , "title" : "Twenty-six" , "number" : require("@/assets/visual/gamecomic/Comic_26.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_027.png") , "title" : "Twenty-seven" , "number" : require("@/assets/visual/gamecomic/Comic_27.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_028.png") , "title" : "Twenty-eight" , "number" : require("@/assets/visual/gamecomic/Comic_28.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_029.png") , "title" : "Twenty-nine" , "number" : require("@/assets/visual/gamecomic/Comic_29.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_030.png") , "title" : "Thirty" , "number" : require("@/assets/visual/gamecomic/Comic_30.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_031.png") , "title" : "Thirty-one" , "number" : require("@/assets/visual/gamecomic/Comic_31.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_032.png") , "title" : "Thirty-two" , "number" : require("@/assets/visual/gamecomic/Comic_32.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_033.png") , "title" : "Thirty-three" , "number" : require("@/assets/visual/gamecomic/Comic_33.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_034.png") , "title" : "Thirty-four" , "number" : require("@/assets/visual/gamecomic/Comic_34.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_035.png") , "title" : "Thirty-five" , "number" : require("@/assets/visual/gamecomic/Comic_35.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_036.png") , "title" : "Thirty-six" , "number" : require("@/assets/visual/gamecomic/Comic_36.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_037.png") , "title" : "Thirty-seven" , "number" : require("@/assets/visual/gamecomic/Comic_37.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_038.png") , "title" : "Thirty-eight" , "number" : require("@/assets/visual/gamecomic/Comic_38.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_039.png") , "title" : "Thirty-nine" , "number" : require("@/assets/visual/gamecomic/Comic_39.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_040.png") , "title" : "Forty" , "number" : require("@/assets/visual/gamecomic/Comic_40.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_041.png") , "title" : "Forty-one" , "number" : require("@/assets/visual/gamecomic/Comic_41.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_042.png") , "title" : "Forty-two" , "number" : require("@/assets/visual/gamecomic/Comic_42.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_043.png") , "title" : "Forty-three" , "number" : require("@/assets/visual/gamecomic/Comic_43.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_044.png") , "title" : "Forty-four" , "number" : require("@/assets/visual/gamecomic/Comic_44.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_045.png") , "title" : "Forty-five" , "number" : require("@/assets/visual/gamecomic/Comic_45.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_046.png") , "title" : "Forty-six" , "number" : require("@/assets/visual/gamecomic/Comic_46.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_047.png") , "title" : "Forty-seven" , "number" : require("@/assets/visual/gamecomic/Comic_47.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_048.png") , "title" : "Forty-eight" , "number" : require("@/assets/visual/gamecomic/Comic_48.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_049.png") , "title" : "Forty-nine" , "number" : require("@/assets/visual/gamecomic/Comic_49.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_050.png") , "title" : "Fifty" , "number" : require("@/assets/visual/gamecomic/Comic_50.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_051.png") , "title" : "Fifty-one" , "number" : require("@/assets/visual/gamecomic/Comic_51.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_052.png") , "title" : "Fifty-two" , "number" : require("@/assets/visual/gamecomic/Comic_52.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_053.png") , "title" : "Fifty-three" , "number" : require("@/assets/visual/gamecomic/Comic_53.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_054.png") , "title" : "Fifty-four" , "number" : require("@/assets/visual/gamecomic/Comic_54.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_055.png") , "title" : "Fifty-five" , "number" : require("@/assets/visual/gamecomic/Comic_55.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_056.png") , "title" : "Fifty-six" , "number" : require("@/assets/visual/gamecomic/Comic_56.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_057.png") , "title" : "Fifty-seven" , "number" : require("@/assets/visual/gamecomic/Comic_57.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_058.png") , "title" : "Fifty-height" , "number" : require("@/assets/visual/gamecomic/Comic_58.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_059.png") , "title" : "Fifty-nine" , "number" : require("@/assets/visual/gamecomic/Comic_59.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_060.png") , "title" : "Sixty" , "number" : require("@/assets/visual/gamecomic/Comic_60.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_061.png") , "title" : "Sixty-one" , "number" : require("@/assets/visual/gamecomic/Comic_61.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_062.png") , "title" : "Sixty-two" , "number" : require("@/assets/visual/gamecomic/Comic_62.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_063.png") , "title" : "Sixty-three" , "number" : require("@/assets/visual/gamecomic/Comic_63.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_064.png") , "title" : "Sixty-four" , "number" : require("@/assets/visual/gamecomic/Comic_64.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_065.png") , "title" : "Sixty-five" , "number" : require("@/assets/visual/gamecomic/Comic_65.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_066.png") , "title" : "Sixty-six" , "number" : require("@/assets/visual/gamecomic/Comic_66.png")},
        {"picture" : require("@/assets/visual/gamecomic/TeamComic_067.png") , "title" : "Sixty-seven" , "number" : require("@/assets/visual/gamecomic/Comic_67.png")}
      ]
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div#comic{
	text-align:center;
  margin:auto;
}
.gameComic{
    text-align: center;
    padding:5% 20% 0 10%;
    font-family: 'Open Sans', sans-serif;
    font-size: 0.8em;
}
.ctrlBtn{
  border: none;
  padding:10px;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-size: 24px;
  text-align: center;
  cursor: pointer;
  outline: none;
  color: #fff;
  background-color: rgb(236, 234, 234);
  border: none;
  border-radius: 35px;
  box-shadow: 0 5px rgb(212, 212, 212);
}

.disableCtrlBtn{
  border: none;
  padding:10px;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-size: 24px;
  text-align: center;
  cursor: pointer;
  outline: none;
  color: #fff;
  background-color: rgb(236, 234, 234);
  border: none;
  border-radius: 35px;
  transform: translateY(4px);
  opacity: 0.2;
}

.ctrlBtn:hover{
  background-color:#d8d7d7;
  box-shadow: 0 5px rgb(255, 94, 94);
}

.ctrlBtn:active{
  box-shadow: 0 5px rgb(155, 84, 84);
  transform: translateY(4px);
}

.comicSize{
  width:94%;
}
div#numberhere{
   margin-left:auto;
   margin-right:auto;
   margin-top:2%;
   margin-bottom:2%;
   display:block;
   text-align:center;
}

#comicHere{
  margin-left:auto;
   margin-right:auto;
   display:block;
   text-align:center;
}

div #first, div#previous,  div#next, div#last {
	display:inline;
	margin-left:1%;
	margin-right:1%;
}
div#previous {
	padding-right:2%;
}

div#next {
	padding-left:2%;
}

div#buttonsTop {
	padding-top:0px;
}



</style>
